import { render, staticRenderFns } from "./QueueInvoice.vue?vue&type=template&id=9be05824&"
import script from "./QueueInvoice.vue?vue&type=script&lang=js&"
export * from "./QueueInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports